// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"PayPalSettingsList_contentComponent__1egdv","tableContainer":"PayPalSettingsList_tableContainer__3v7IV","root":"PayPalSettingsList_root__2IGR_"};